import { SystemSessions } from "@graylog/server-api";
import { qualifyUrl } from "util/URLUtils";
import { Builder } from "logic/rest/FetchProvider";
import Session from "logic/session/Session";
export const login = (username, password, host) => SystemSessions.newSession({ username, password, host }).then((response) => {
  Session.setUsername(response.username);
  return { username: response.username };
});
const terminateSession = () => new Builder("DELETE", qualifyUrl("/system/sessions/")).build().then(
  (response) => {
    if (response.ok || response.status === 401) {
      Session.endSession();
    }
  },
  () => Session.endSession()
).then(() => Session.notifyLogout());
Session.setLogoutHandler(terminateSession);
export const logout = () => Session.logout();
let pendingValidation;
const validateSession = () => {
  const storedUsername = Session.storedUsername();
  return SystemSessions.validateSession().then((response) => {
    var _a;
    if (response.is_valid) {
      Session.setUsername((_a = response.username) != null ? _a : storedUsername);
    } else if (storedUsername) {
      Session.setUsername(void 0);
    }
    Session.notifyValidated();
    return response;
  }).finally(() => {
    pendingValidation = void 0;
  });
};
export const validate = () => {
  pendingValidation != null ? pendingValidation : pendingValidation = validateSession();
  return pendingValidation;
};
